import { minLength, maxLength, stringPattern, stringPatternError, tagMinLength, tagMaxLength } from '../../utils/form-validations';

export const addTemplateDefFields = {
    id: 0,
    template_id: 0,
    template_name: '',
    template_tags: [],
};

export const addSecretDefFields = {
    id: 0,
    secret_id: 0,
    secret_name: '',
    template_id:0,
    secret_tags: [],
    secret_string:''
};


export const addTemplateUISchema = [
    { id: 1, label: 'Secret Template Name', name: 'template_name', type: 'input', required: true }
];

export const templateFormSchema = {
    type: 'object',
    properties: {
        template_name: {
            type: 'string',
            minLength,
            maxLength,
            pattern: stringPattern,
            errorMessage: { pattern: stringPatternError },
        },       
    },
    required: ['template_name'],
    additionalProperties: true,
};

export const addSecretUISchema = [
    { id: 1, label: 'Secret Name', name: 'secret_name', type: 'input', required: true },
    { id: 2, label: 'Secret Template', name: 'template_id', type: 'select', required: true }
];

export const secretFormSchema = {
    type: 'object',
    properties: {
        secret_name: {
            type: 'string',
            minLength,
            maxLength,
            pattern: stringPattern,
            errorMessage: { pattern: stringPatternError },
        },
        // template_id: {
        //     type: 'string',
        //     minLength,
        //     maxLength,
        //     pattern: stringPattern,
        //     errorMessage: { pattern: stringPatternError },
        // }
    },
    required: ['secret_name'],
    additionalProperties: true,
};

export const templateTagsSchema = {
    type: 'object',
    properties: {
        id: { type: 'number' },
        key: {
            type: 'string',
            minLength: tagMinLength,
            maxLength: tagMaxLength,
            pattern: stringPattern,
            errorMessage: { pattern: stringPatternError },
        },       
    },
    required: ['key'],
    additionalProperties: true,
};

export const secretTagsSchema = {
    type: 'object',
    properties: {
        id: { type: 'number' },
        key: {
            type: 'string',
            minLength: tagMinLength,
            maxLength: tagMaxLength,
            // pattern: stringPattern,
            // errorMessage: { pattern: stringPatternError },
        },
        value: {
            type: 'string',
            minLength: tagMinLength,
            // maxLength: tagMaxLength,
            // pattern: stringPattern,
            // errorMessage: { pattern: stringPatternError },
        }
    },
    required: ['key', 'value'],
    additionalProperties: true,
};
